import { defineActions } from './defineActions'

/**
 * Payments and invoices. Action names start with Payment (PaymentSection is shared between
 * modules; the module comes from the page's subject), except the actions of IME-only pages.
 *
 * The section's Save is the page footer's Ime.Payment.Save (ime-page.ts). Uploading a file into
 * a payment field only stores the file: the attachment is saved (and recorded) by that Save.
 */
export const paymentActions = defineActions({
  'Payment.ResendPaymentReceiptToCompany': {
    label: 'Resend payment receipt to booking company',
    area: 'Payment',
  },
  'Payment.ResendInvoiceToStaff': {
    label: 'Resend provider invoice to staff',
    area: 'Payment',
  },
  'Payment.ResendPaymentReceiptToProvider': {
    label: 'Resend payment receipt to provider',
    area: 'Payment',
  },
  'Payment.ResendPaymentReceiptToStaff': {
    label: 'Resend payment receipt to staff',
    area: 'Payment',
  },
  'Ime.Payment.UploadInvoice': {
    label: 'Upload invoice',
    area: 'Payment',
    description:
      'Save in the Upload Invoice modal of the Specialist Dashboard (saves the Payment section).',
  },
})
